module.exports = __webpack_public_path__ + "img/home-rbn-9.2da262a3.png";